import { TranscriptTypeEnum } from '../../enum';

export class TranscriptEventDto {
  text: string;
  type: TranscriptTypeEnum;
}